// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("account.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*background-color: #036A47;
    color: white;*/
    color: rgba(0, 0, 0, 0.85);
    padding: 10px 20px;
    border-bottom: #F2F2F2 2px solid;
    font-family: "Arial Regular", "Helvetica Neue", Helvetica, sans-serif;
    font-size: 14px;
    font-variant: tabular-nums;
    font-feature-settings: tabular-nums;
}

.header-section {
    flex: none;
    text-align: center;
    margin-right: 20px;
}

.project-name {
    flex: none;
    text-align: left;
    color: rgb(50, 83, 220);
    margin-right: 10px;
    font-size: 1.5rem !important;
}

h4 {
    margin: 0;
    font-family: "Qualcomm Next";
}

h3 {
    margin: 0;
    font-family: "Qualcomm Next";
}

.tabs {
    flex: 1 1;
    display: flex;
    justify-content: center;
}

.tab-dropdown {
    position: relative;
    margin: 0 20px;
    cursor: pointer;
    margin-top: -1px;
    margin-bottom: 0;
}

.tab-name {
    padding: 5px;
    transition: color 0.3s;
}

.tab-name.active {
    color: rgb(50, 83, 220);
    border-bottom: 2px solid rgb(50, 83, 220);
    padding-bottom: 20px;
}

.tab-dropdown:hover .tab-name {
    color: rgb(50, 83, 220);
    padding-bottom: 20px;
    border-bottom: 2px solid rgb(50, 83, 220);
    position: relative;
}

.tab-dropdown:hover .tab-name::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -11px;
    height: 2px;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #ffffff;
    box-shadow: 0px 8px 16px rgba(0,0,0,0.2);
    z-index: 1;
    margin-top: 25px;
    width: 225px;
}

.tab-dropdown:hover .dropdown-content {
    display: block;
    pointer-events: auto;
}

.dropdown-item {
    padding: 12px 15px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
}

.dropdown-item:hover {
    background-color: transparent;
    color: rgb(50, 83, 220);
}

.user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 20px;
}

.user-icon-btn {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 27px;
    height: 25px;
    background-color: inherit;
    color: white;
    border: none;
    margin-right: 5px;
}

.footer-detail-section {
    color: rgb(103, 114, 132);
    font-size: 12px;
    margin-bottom: 0.5rem;
    line-height: 2;
}

.row-footer {
    display: flex;
    justify-content: space-between;
    align-items: center; 
}

.contact-qsd-team {
    border: 1px solid rgb(73, 89, 118);
    color: rgb(103, 114, 132);
    background-color: transparent;
    font-weight: bold;
    border-radius: 12px;
    padding: 7px;
    font-size: 14px;
    margin-left: auto;
    margin-right: 10px;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/assets/Header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB;kBACc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,gCAAgC;IAChC,qEAAqE;IACrE,eAAe;IACf,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,4BAA4B;AAChC;;AAEA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;IACxC,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yDAAoC;IACpC,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":[".header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /*background-color: #036A47;\n    color: white;*/\n    color: rgba(0, 0, 0, 0.85);\n    padding: 10px 20px;\n    border-bottom: #F2F2F2 2px solid;\n    font-family: \"Arial Regular\", \"Helvetica Neue\", Helvetica, sans-serif;\n    font-size: 14px;\n    font-variant: tabular-nums;\n    font-feature-settings: tabular-nums;\n}\n\n.header-section {\n    flex: none;\n    text-align: center;\n    margin-right: 20px;\n}\n\n.project-name {\n    flex: none;\n    text-align: left;\n    color: rgb(50, 83, 220);\n    margin-right: 10px;\n    font-size: 1.5rem !important;\n}\n\nh4 {\n    margin: 0;\n    font-family: \"Qualcomm Next\";\n}\n\nh3 {\n    margin: 0;\n    font-family: \"Qualcomm Next\";\n}\n\n.tabs {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n}\n\n.tab-dropdown {\n    position: relative;\n    margin: 0 20px;\n    cursor: pointer;\n    margin-top: -1px;\n    margin-bottom: 0;\n}\n\n.tab-name {\n    padding: 5px;\n    transition: color 0.3s;\n}\n\n.tab-name.active {\n    color: rgb(50, 83, 220);\n    border-bottom: 2px solid rgb(50, 83, 220);\n    padding-bottom: 20px;\n}\n\n.tab-dropdown:hover .tab-name {\n    color: rgb(50, 83, 220);\n    padding-bottom: 20px;\n    border-bottom: 2px solid rgb(50, 83, 220);\n    position: relative;\n}\n\n.tab-dropdown:hover .tab-name::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -11px;\n    height: 2px;\n}\n\n.dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: #ffffff;\n    box-shadow: 0px 8px 16px rgba(0,0,0,0.2);\n    z-index: 1;\n    margin-top: 25px;\n    width: 225px;\n}\n\n.tab-dropdown:hover .dropdown-content {\n    display: block;\n    pointer-events: auto;\n}\n\n.dropdown-item {\n    padding: 12px 15px;\n    cursor: pointer;\n    color: rgba(0, 0, 0, 0.85);\n    text-align: left;\n}\n\n.dropdown-item:hover {\n    background-color: transparent;\n    color: rgb(50, 83, 220);\n}\n\n.user-info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-right: 20px;\n}\n\n.user-icon-btn {\n    background-image: url('account.svg');\n    width: 27px;\n    height: 25px;\n    background-color: inherit;\n    color: white;\n    border: none;\n    margin-right: 5px;\n}\n\n.footer-detail-section {\n    color: rgb(103, 114, 132);\n    font-size: 12px;\n    margin-bottom: 0.5rem;\n    line-height: 2;\n}\n\n.row-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; \n}\n\n.contact-qsd-team {\n    border: 1px solid rgb(73, 89, 118);\n    color: rgb(103, 114, 132);\n    background-color: transparent;\n    font-weight: bold;\n    border-radius: 12px;\n    padding: 7px;\n    font-size: 14px;\n    margin-left: auto;\n    margin-right: 10px;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
